import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon } from 'lucide-react';
interface AgingBucketsProps {
  highlight: boolean;
  phase: number;
  isRecomputing?: boolean;
}
export function AgingBuckets({
  highlight,
  phase,
  isRecomputing
}: AgingBucketsProps) {
  const buckets = [{
    label: 'Current (0-30d)',
    value: 96.3,
    isHighlight: true
  }, {
    label: '31-60 days',
    value: 2.8,
    isHighlight: false
  }, {
    label: '61-90 days',
    value: 0.7,
    isHighlight: false
  }, {
    label: '90+ days',
    value: 0.2,
    isHighlight: false
  }];
  return <div className={`bg-slate-900 border rounded p-3.5 h-full transition-colors ${isRecomputing ? 'border-emerald-500/50' : 'border-slate-800'}`} data-id="element-98">
      <div className="flex items-center justify-between mb-3 pt-2" data-id="element-99">
        <h3 className="text-base font-semibold text-slate-300 tracking-tight" data-id="element-100">
          Aging Buckets
        </h3>
        <ClockIcon size={16} className="text-slate-600" data-id="element-101" />
      </div>

      <div className="mb-3" data-id="element-102">
        <div className="text-[10px] text-slate-500 uppercase tracking-wide mb-1" data-id="element-103">
          On-Time Payment Rate
        </div>
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: phase >= 2 ? 1 : 0,
        scale: isRecomputing ? [1, 1.05, 1] : 1
      }} transition={{
        duration: 0.4
      }} className={`text-[32px] font-mono font-semibold leading-none ${isRecomputing ? 'text-emerald-400' : 'text-emerald-400'}`} data-id="element-104">
          96.3%
        </motion.div>
      </div>

      <div className="space-y-2.5" data-id="element-105">
        {buckets.map((bucket, index) => <motion.div key={bucket.label} initial={{
        opacity: 0,
        x: -10
      }} animate={{
        opacity: phase >= 2 ? 1 : 0,
        x: phase >= 2 ? 0 : -10
      }} transition={{
        delay: index * 0.05,
        duration: 0.2
      }} data-id="element-106">
            <div className="flex items-center justify-between text-[11px] mb-1.5" data-id="element-107">
              <span className="text-slate-400" data-id="element-108">{bucket.label}</span>
              <motion.span animate={{
            color: highlight && bucket.isHighlight || isRecomputing ? '#10b981' : '#94a3b8',
            scale: highlight && bucket.isHighlight || isRecomputing ? [1, 1.05, 1] : 1
          }} transition={{
            duration: 0.4
          }} className="font-mono font-semibold text-[13px]" data-id="element-109">
                {bucket.value.toFixed(1)}%
              </motion.span>
            </div>
            <div className="h-2 bg-slate-800 rounded-full overflow-hidden" data-id="element-110">
              <motion.div initial={{
            width: 0
          }} animate={{
            width: phase >= 2 ? `${bucket.value}%` : 0,
            backgroundColor: highlight && bucket.isHighlight || isRecomputing ? '#10b981' : '#475569'
          }} transition={{
            duration: 0.3,
            delay: index * 0.05
          }} className="h-full" data-id="element-111" />
            </div>
          </motion.div>)}
      </div>

      {highlight && phase >= 2 && <motion.div initial={{
      opacity: 0,
      scale: 0.98
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.2
    }} className="mt-3 pt-3 border-t border-slate-800" data-id="element-112">
          <div className="text-[9px] text-slate-400" data-id="element-113">
            Less than 1% beyond 90 days.
          </div>
        </motion.div>}
    </div>;
}